'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPassword$0024$0024anon$002482 from "./presto.types$-Password$$anon$82.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Password$() {
  this.c7u = null;
  this.c7v = false;
  this.c7w = null;
  this.c7x = false;
}
export { $c_Lpresto_types$Password$ as $c_Lpresto_types$Password$ };
$p = $c_Lpresto_types$Password$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Password$;
/** @constructor */
function $h_Lpresto_types$Password$() {
}
export { $h_Lpresto_types$Password$ as $h_Lpresto_types$Password$ };
$h_Lpresto_types$Password$.prototype = $p;
$p.crC = (function() {
  if ((!this.c7v)) {
    this.c7u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7v = true;
  }
  return this.c7u;
});
$p.a2B = (function() {
  if ((!this.c7x)) {
    this.c7w = new $j_presto$002etypes$0024$002dPassword$0024$0024anon$002482.$c_Lpresto_types$Password$$anon$82(this);
    this.c7x = true;
  }
  return this.c7w;
});
$p.SN = (function(it) {
  return (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(it) === "") || ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(it).length < 6));
});
var $d_Lpresto_types$Password$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Password$, "presto.types$Password$", ({
  a12: 1,
  D: 1
}));
export { $d_Lpresto_types$Password$ as $d_Lpresto_types$Password$ };
var $n_Lpresto_types$Password$;
function $m_Lpresto_types$Password$() {
  if ((!$n_Lpresto_types$Password$)) {
    $n_Lpresto_types$Password$ = new $c_Lpresto_types$Password$();
  }
  return $n_Lpresto_types$Password$;
}
export { $m_Lpresto_types$Password$ as $m_Lpresto_types$Password$ };
//# sourceMappingURL=presto.types$-Password$.js.map
